import { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router'
import {
  CONSIGNMENT_SERVER_STATUS,
  getConsignmentsUrlWithCurrentParams,
  useCurrentConsignment,
} from '~/entities/consignment'
import { useUserStore } from '~/entities/user'
import { Button, Dialog, OptiWalking, Text } from '~/shared/ui'

export function CheckConsignmentAssigneeDialog() {
  const navigate = useNavigate()
  const { data } = useCurrentConsignment()
  const userInfo = useUserStore((state) => state.userInfo)

  const isOtherUserAssigned = useMemo(() => {
    if (
      data.consignment.review_status === CONSIGNMENT_SERVER_STATUS.reviewed ||
      data.consignment.review_status === CONSIGNMENT_SERVER_STATUS.auto_reviewed
    ) {
      return false
    }

    return (
      data.consignment.reviewer?.sub &&
      userInfo?.email &&
      data.consignment.reviewer.sub !== userInfo.email
    )
  }, [data.consignment.review_status, data.consignment.reviewer?.sub, userInfo?.email])

  const onSubmit = useCallback(() => {
    navigate(getConsignmentsUrlWithCurrentParams())
  }, [navigate])

  if (!isOtherUserAssigned) {
    return null
  }

  return (
    <Dialog
      open={isOtherUserAssigned}
      size="sm"
      onClose={onSubmit}
      actions={
        <Button
          raised
          onClick={onSubmit}
        >
          Go to queue
        </Button>
      }
    >
      <div className="flex flex-col gap-4">
        <OptiWalking />
        <div className="flex flex-col gap-2">
          <Text
            className="text-text-primary"
            appearance="SUBTITLE2"
          >
            Hang tight! This one's already taken.
          </Text>
          <Text
            className="text-text-secondary"
            appearance="CAPTION"
          >
            Looks like your teammate just started reviewing this consignment a few seconds ago.
            <br />
            To keep things tidy and avoid duplicate work, please return to the work queue and pick
            the next available consignment.
          </Text>
        </div>
      </div>
    </Dialog>
  )
}
